import { render, staticRenderFns } from "./InquiryHistory.vue?vue&type=template&id=43e04f55&scoped=true"
import script from "./InquiryHistory.vue?vue&type=script&lang=js"
export * from "./InquiryHistory.vue?vue&type=script&lang=js"
import style0 from "./InquiryHistory.vue?vue&type=style&index=0&id=43e04f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e04f55",
  null
  
)

export default component.exports